/*
 * © 2020 Microsoft. All rights reserved.
 */

define('MenuUI/GameOptionsPopup',['pixi', 'absolute', 'absolute/stringmanager', 'Managers/ScaleManager',
	'Arkadium/GameEngine/Scenes/Nodes/SpriteNode', 'lodash', 'MenuUI/MsftButton',
	'MenuUI/MsftIconButton', 'MenuUI/InputButton', 'MenuUI/MsftSlideOutIconButton', 'MenuUI/RadioGroup',
	'MenuUI/MsftToggleButton', 'util/SettingsManager', 'MenuUI/SideBar', 'util/eventhandler',
	'MenuUI/ControlFocusManager', 'Managers/ScrollManager', 'MenuUI/DealWarningModal'],
	function (PIXI, Absolute, _s, ScaleManager, SpriteNode, _,
		MsftButton, MsftIconButton, InputButton, IconButton,
		RadioGroup, MsftToggleButton, SettingsManager, SideBar,
		EventHandler, ControlFocusManager, ScrollManager, DealWarningModal) {
		var GameOptionsPopup = function (config, game) {
			this.initialize(config, game);
		};

		GameOptionsPopup.constructor = GameOptionsPopup;
		GameOptionsPopup.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);


		GameOptionsPopup.prototype.initialize = function (config, game) {
			PIXI.DisplayObjectContainer.call(this);
			this.initVariables(config, game);

			this.initOverlay();
			this.initPopupContainer();
			this.initBackground();
			this.initHeader();
			this.initHeaderLabel();
			this.initControlFocusManager();
			this.initBodyContainer();
			this.initBodyContent();
			this.initBodyMask();
			this.initCloseButton();

			this.positionPopupContainer();

			// Scrolling
			this.initSideBar();
			this.initScrolling();

			this.initTouchInterface();

			this.updateChildIndexes();
			//Initializing
			this.alpha = 0;
			this.overlay.alpha = 0;
			this.focusGroupToggle = false;
			this.openPopup();
			// Scaling
			ScaleManager.addElement(this, { scaleChangeSource: 'Full' })
		};

		GameOptionsPopup.prototype.handleResize = function () {
			var scaleX = ScaleManager.scaleFactorX,
				scaleY = ScaleManager.scaleFactorY;
			this.scrollTo(this.bodyContainer.y + this.header.height);
			var scaleFactor = this.config.popupWidth / (Absolute.Coords.y(1080) * 0.6);

			if (ScaleManager.scaleFactorY >= 0.6) {
				this.popupContainer.scale.x = 1 / scaleX;
				this.popupContainer.scale.y = 1 / scaleY;
				this.updateSidebar(true);
			} else {
				this.popupContainer.scale.y = 1 / 0.6;
				this.popupContainer.width = Absolute.Coords.y(ScaleManager.height) * ((scaleFactor) / scaleX);
				this.updateSidebar(false);
			}

			if (ScaleManager.width < 420 && ScaleManager.height > 550) { // A fix to a real scaling problem
				var scaleFactorMobile = this.config.popupWidth / (Absolute.Coords.x(640) * 0.23);
				this.popupContainer.height = Absolute.Coords.x(ScaleManager.width) * ((scaleFactorMobile) / scaleY);
				this.popupContainer.scale.x = 1 / 0.23;
				this.popupContainer.scale.y = 1 / scaleY;
				this.updateSidebar(true);
			}

			this.resizeMask(scaleY);
			this.popupContainer.x = (Absolute.Coords.x(1920) - this.popupContainer.width) * 0.5;
			this.popupContainer.y = (Absolute.Coords.x(1080) - this.background.height) * 0.5;
			this.background.clear();
			this.background.beginFill(0x12366a);
			this.background.drawRect(0, 0, this.config.popupWidth,
				this.config.popupHeight * (scaleY >= 0.6 ? scaleY : 0.6));
			this.background.endFill();
			this.background.hitArea = new PIXI.Rectangle(0, 0, this.config.popupWidth,
				this.config.popupHeight * (scaleY >= 0.6 ? scaleY : 0.6));
			if (this.inputButton) {
				this.inputButton.disable();
			}
		};

		GameOptionsPopup.prototype.resizeMask = function (scaleY) {
			this.maskRef.scale.y = scaleY >= 0.6 ? scaleY : 0.6;
		};

		GameOptionsPopup.prototype.initVariables = function (config, game) {
			this.game = game;
			this.overlay = null;
			this.background = null;
			this.header = null;
			this.headerLabel = null;
			this.popupContainer = null;
			this.closeBtn = null;
			this.bodyContainer = null;
			this.layoutConfig = null;
			this.settingsManager = SettingsManager;
			this.previousBtnY = 0;
			this.previousBtnHeight = 0;
			this.bodyHeight = 0;
			this.onClose = new EventHandler();

			this.config = _.extend({
				letterStyle: {
					font: Absolute.ScreenMetrics.getResScale() * 28 + "px Arial",
					fontFamily: 'segoe',
					fill: '#ffffff',
					align: 'left'
				},
				popupWidth: Absolute.Coords.x(420),
				popupHeight: Absolute.Coords.y(980),
				headerWidth: Absolute.Coords.x(420),
				headerHeight: Absolute.Coords.y(56),
				bodyPadding: Absolute.Coords.y(5),
				buttonHandler: '',
				optionsName: 'Klondike'
			}, config);
			console.log(this.config.optionsName || 'Main Menu');

			this.specificOptionName = 'GameOptions' + this.config.optionsName;
			this.sharedOptionsName = 'GameOptionsShared';
			this.showDifficultyName = 'GameOptionsShowDifficulty';
			this.tutorialOptionsName = 'GameOptionsTutorials';
		};

		GameOptionsPopup.prototype.initOverlay = function () {
			var overlay = new PIXI.Graphics();
			overlay.beginFill(0, 0.8);
			overlay.drawRect(0, 0, Absolute.Coords.x(1920), Absolute.Coords.y(1080));
			overlay.endFill();
			overlay.interactive = true;
			overlay.buttonMode = false;
			overlay.hitArea = new PIXI.Rectangle(0, 0, Absolute.Coords.x(1920), Absolute.Coords.y(1080));
			Absolute.SpriteUtils.bindInteraction(overlay, this.closePopup.bind(this));
			overlay.mouseup = function () {
			};
			this.overlay = overlay;
		};

		GameOptionsPopup.prototype.initPopupContainer = function () {
			this.popupContainer = new PIXI.DisplayObjectContainer();
			this.addChild(this.popupContainer);
		};

		GameOptionsPopup.prototype.initBackground = function () {
			var background = new PIXI.Graphics();
			background.beginFill(0x12366a);
			background.drawRect(0, 0, this.config.popupWidth, this.config.popupHeight);
			background.endFill();
			background.hitArea = new PIXI.Rectangle(0, 0, this.config.popupWidth, this.config.popupHeight);
			Absolute.SpriteUtils.bindInteraction(background, function () {
			});
			background.mouseup = function () {
			};
			this.popupContainer.addChild(background);
			this.background = background;
		};

		GameOptionsPopup.prototype.initHeader = function () {
			var header = new PIXI.Graphics();
			header.beginFill(0x2672ea);
			header.drawRect(0, 0, this.config.headerWidth, this.config.headerHeight);
			header.endFill();
			this.popupContainer.addChild(header);
			this.header = header;
		};

		GameOptionsPopup.prototype.initHeaderLabel = function () {
			var headerLabel = new PIXI.Text(_s('titles.gameOptions'), this.config.letterStyle);
			headerLabel.position.set(
				(this.header.width - headerLabel.width) * 0.5,
				(this.header.height - headerLabel.height) * 0.5 + Absolute.Coords.y(3)
			);
			this.popupContainer.addChild(headerLabel);
			this.headerLabel = headerLabel;
		};

		GameOptionsPopup.prototype.initCloseButton = function () {
			var closeBtn = new SpriteNode('Buttons/Deal/Deal.png');
			closeBtn.rotation = Math.PI / 4;
			closeBtn.position.set(
				this.header.width - closeBtn.width - Absolute.Coords.x(10),
				(this.header.height) * 0.5
			);
			closeBtn.interactive = true;
			closeBtn.buttonMode = true;
			closeBtn.onMouseDownEvent = function () {
				this.closePopup();
			}.bind(this);
			closeBtn.PointDown.add(function () {
				this.closePopup();
			}.bind(this));
			this.popupContainer.addChild(closeBtn);
			closeBtn.handleActivate = function () {
				Absolute.AudioManager.playSound('button');
				this.closePopup();
			}.bind(this);
			this.controlFocusManager.addControl(closeBtn, false, 'close');
			this.closeBtn = closeBtn;
			this.createCloseButtonHighlight();
			this.controlFocusManager.setFocusGroup('body', true);
		};

		GameOptionsPopup.prototype.createCloseButtonHighlight = function () {
			var btnHighlight = new PIXI.Graphics(),
				offset = Absolute.Coords.x(5);
			btnHighlight.beginFill(0, 0);
			btnHighlight.lineStyle(1, 0xffffff);
			btnHighlight.drawRect(0, 0, this.closeBtn.width + offset, this.closeBtn.height + offset);
			btnHighlight.position.set(
				this.closeBtn.x - (offset + this.closeBtn.width) / 2,
				this.closeBtn.y - (offset + this.closeBtn.height) / 2
			);
			btnHighlight.endFill();
			this.closeBtn.highlight = btnHighlight;
		};

		GameOptionsPopup.prototype.initBodyContainer = function () {
			var bodyContainer = new PIXI.DisplayObjectContainer();
			bodyContainer.y = this.header.y + this.header.height + this.config.bodyPadding;
			this.popupContainer.addChild(bodyContainer);
			this.bodyContainer = bodyContainer;
		};

		GameOptionsPopup.prototype.initControlFocusManager = function () {
			this.controlFocusManager = new ControlFocusManager();
		};

		GameOptionsPopup.prototype.initBodyContent = function () {
			this.initOptionsContent(this.specificOptionName);
			this.initOptionsContent(this.sharedOptionsName);
			this.bodyHeight = this.previousBtnY + this.previousBtnHeight;
			if (!this.game.config.singleGame.enabled) this.initShowDifficultyOptions();
			if (!this.game.config.singleGame.enabled) this.initShowTutorialOptions();
		};


		GameOptionsPopup.prototype.initBodyMask = function () {
			var mask = new PIXI.Graphics();
			mask.beginFill(0, 0);
			mask.drawRect(0, 0, this.header.width, this.background.height);
			mask.endFill();
			this.popupContainer.addChild(mask);
			this.popupContainer.mask = mask;
			this.maskRef = mask;
		};

		GameOptionsPopup.prototype.initSideBar = function () {
			this.sidebar = new SideBar({
				availableHeight: 200, partialHeight: 100,
				onScrollUpdate: function (p) {
				}.bind(this)
			});
			this.popupContainer.addChild(this.sidebar);
			this.sidebar.position.set(
				Absolute.Coords.x(465),
				this.header.height
			);
			this.sidebar.x = this.popupContainer.width - this.sidebar.width - Absolute.Coords.x(65);
			this.updateSidebar();
		};

		GameOptionsPopup.prototype.initScrolling = function () {
			ScrollManager.add(this, this.doScroll, this);
		};

		GameOptionsPopup.prototype.initTouchInterface = function () {
			// Dragging and panning
			this.lastDeltaY = 0;
			this.startY = 0;
			var hitArea = new PIXI.Rectangle(0, 0, this.config.popupWidth - this.sidebar.width, this.config.popupHeight);
			this.touchContainer = new PIXI.DisplayObjectContainer();
			this.touchContainer.interactive = true;
			this.touchContainer.hitArea = hitArea;
			this.touchContainer.addChild(this.bodyContainer);
			this.touchContainer.mousedown = this.touchContainer.touchstart = this.handleDragStart.bind(this);
			this.touchContainer.mousemove = this.touchContainer.touchmove = this.handleDrag.bind(this);
			this.touchContainer.mouseupoutside = this.touchContainer.mouseup = this.touchContainer.touchend = this.touchContainer.touchendoutside = this.handleDragEnd.bind(this);
			this.popupContainer.addChild(this.touchContainer);
		};

		GameOptionsPopup.prototype.handleDragStart = function (data) {
			this.dragging = true;
			this.lastDeltaY = 0;
			this.startY = data.getLocalPosition(this.parent).y;
		};

		GameOptionsPopup.prototype.handleDragEnd = function (data) {
			this.dragging = false;
			this.enableButtons(true);
		};

		GameOptionsPopup.prototype.handleDrag = function (data) {
			if (!this.dragging) {
				return;
			}

			if (!Absolute.Platform.supportsTouch())
				this.enableButtons(false);


			var pos = data.getLocalPosition(this.parent),
				delta = pos.y - this.startY;

			this.scrollTo(this.bodyContainer.y + (delta - this.lastDeltaY));

			this.lastDeltaY = delta;
		};

		GameOptionsPopup.prototype.enableButtons = function (enable) {
			var i, l;

			for (i = 0, l = this.bodyContainer.children.length; i < l; i++) {
				this.bodyContainer.children[i].interactive = enable;
			}
		};

		GameOptionsPopup.prototype.updateSidebar = function (shouldResize) {
			if (!this.sidebar || !this.bodyContainer) return;
			this.sidebar.scale.set(1, 1);
			var availableHeight, partialHeight, scaleY;
			scaleY = shouldResize ? ScaleManager.scaleFactorY : 0.6;
			availableHeight = this.bodyHeight + Absolute.Coords.y(65) + this.config.popupHeight * (1 - scaleY);
			partialHeight = this.background.height;
			this.sidebar.resetDimensions(availableHeight, partialHeight, function (p) {
				var y = (-(Math.abs(availableHeight - partialHeight)) * p / 100) + this.header.height + this.config.bodyPadding;
				this.bodyContainer.y = y;
				if (this.inputButton) {
					this.inputButton.disable();
				}
			}.bind(this), (partialHeight * scaleY - this.header.height));
			this.sidebar.visible = (partialHeight < availableHeight);
		};

		GameOptionsPopup.prototype.initOptionsContent = function (layoutName) {
			var layoutConfig = Absolute.UIBuilder.getConfigData(layoutName);
			if (!layoutConfig) return;
			if (!layoutConfig.buttonSections) return;
			var buttonsData = layoutConfig.buttonSections[0].buttons;
			if (!buttonsData) return;
			var sectionPrefix = layoutConfig.buttonSections[0].settingsPrefix,
				paddingTop = Absolute.Coords.y(15),
				paddingLeft = Absolute.Coords.x(34);
			buttonsData.forEach(function (btnData, index) {
				var button = this.checkAndCreateButton(btnData, sectionPrefix);
				if (!button) return;
				button.y = this.previousBtnY + this.previousBtnHeight + paddingTop;
				this.previousBtnY = button.y;
				this.previousBtnHeight = button.height;
				button.x = paddingLeft;
				this.bodyContainer.addChild(button);
				this.controlFocusManager.addControl(button, false, 'body')
			}.bind(this));
		};

		GameOptionsPopup.prototype.initShowDifficultyOptions = function () {
			var layout = Absolute.UIBuilder.getConfigData(this.showDifficultyName),
				buttonsSection = layout.buttonSections[0],
				buttonData = buttonsSection.buttons[0],
				games = ['Klondike', 'Spider', 'FreeCell'
					// , 'Pyramid', 'TriPeaks'
				];

			const sectionPrefix = _s(buttonsSection.title)

			var titleLetterStyle = {
				font: Absolute.ScreenMetrics.getResScale() * 28 + "px Arial",
				fontFamily: 'segoe',
				fill: '#ffffff',
				align: 'left'
			},
				descriptionLetterStyle = {
					font: Absolute.ScreenMetrics.getResScale() * 22 + "px Arial",
					fontFamily: 'segoe',
					fill: '#ffffff',
					align: 'left'
				}, title = new PIXI.Text(sectionPrefix, titleLetterStyle),
				paddingTop = Absolute.Coords.y(15),
				paddingLeft = Absolute.Coords.x(34);

			Absolute.StringManager.shrinkToFit(
				title,
				Absolute.StringManager.extractNumbersFromString(titleLetterStyle.font), '', Absolute.Coords.x(300)
			);

			title.x = paddingLeft;
			title.y = this.previousBtnY + this.previousBtnHeight + paddingTop;
			this.bodyContainer.addChild(title);

			this.previousBtnY = title.y;
			this.previousBtnHeight = title.height;

			games.forEach(function (gameName) {
				buttonData.label = gameName;
				buttonData.settingsKey = 'showDifficulty';
				buttonData.action = this.config.buttonHandler.changeSetting;
				var button = this.checkAndCreateButton(buttonData, gameName.toLowerCase());
				var buttonLabel = new PIXI.Text(_s(gameName), descriptionLetterStyle);
				if (!button) return;
				button.y = this.previousBtnY + this.previousBtnHeight + paddingTop;
				buttonLabel.y = this.previousBtnY + this.previousBtnHeight + paddingTop;
				this.previousBtnY = button.y;
				this.previousBtnHeight = button.height;
				buttonLabel.x = paddingLeft;
				button.x = Absolute.Coords.x(150);

				Absolute.StringManager.shrinkToFit(
					buttonLabel,
					Absolute.StringManager.extractNumbersFromString(descriptionLetterStyle.font), '', Absolute.Coords.x(110)
				);

				this.bodyContainer.addChild(buttonLabel);
				this.bodyContainer.addChild(button);
				this._modifyButtonInput(button);
				this.controlFocusManager.addControl(button, false, 'body')
			}.bind(this));
			this.bodyHeight = this.previousBtnY + this.previousBtnHeight;
			// this.controlFocusManager.focusCurrentControl();
		};

		GameOptionsPopup.prototype.initShowTutorialOptions = function () {
			var layout = Absolute.UIBuilder.getConfigData(this.tutorialOptionsName),
				buttonsSection = layout.buttonSections[0],
				buttonData = buttonsSection.buttons[0],
				games = ['Klondike', 'Spider', 'FreeCell', 'Pyramid', 'TriPeaks'];


			const sectionPrefix = _s(buttonsSection.title)

			var titleLetterStyle = {
				font: Absolute.ScreenMetrics.getResScale() * 28 + "px Arial",
				fontFamily: 'segoe',
				fill: '#ffffff',
				align: 'left'
			},
				descriptionLetterStyle = {
					font: Absolute.ScreenMetrics.getResScale() * 22 + "px Arial",
					fontFamily: 'segoe',
					fill: '#ffffff',
					align: 'left'
				}, title = new PIXI.Text(sectionPrefix, titleLetterStyle),
				paddingTop = Absolute.Coords.y(15),
				paddingLeft = Absolute.Coords.x(34);

			Absolute.StringManager.shrinkToFit(
				title,
				Absolute.StringManager.extractNumbersFromString(titleLetterStyle.font), '', Absolute.Coords.x(300)
			);

			title.x = paddingLeft;
			title.y = this.previousBtnY + this.previousBtnHeight + paddingTop;
			this.bodyContainer.addChild(title);

			this.previousBtnY = title.y;
			this.previousBtnHeight = title.height;

			games.forEach(function (gameName) {
				buttonData.label = gameName;
				buttonData.settingsKey = 'showTutorial';
				buttonData.action = this.config.buttonHandler.changeSetting;
				var button = this.checkAndCreateButton(buttonData, gameName.toLowerCase());
				var buttonLabel = new PIXI.Text(_s(gameName), descriptionLetterStyle);
				if (!button) return;
				button.y = this.previousBtnY + this.previousBtnHeight + paddingTop;
				buttonLabel.y = this.previousBtnY + this.previousBtnHeight + paddingTop;
				this.previousBtnY = button.y;
				this.previousBtnHeight = button.height;
				buttonLabel.x = paddingLeft;
				button.x = Absolute.Coords.x(150);

				Absolute.StringManager.shrinkToFit(
					buttonLabel,
					Absolute.StringManager.extractNumbersFromString(descriptionLetterStyle.font), '', Absolute.Coords.x(110)
				);

				this.bodyContainer.addChild(buttonLabel);
				this.bodyContainer.addChild(button);
				this._modifyButtonInput(button);
				this.controlFocusManager.addControl(button, false, 'body')
			}.bind(this));
			this.bodyHeight = this.previousBtnY + this.previousBtnHeight;
			// this.controlFocusManager.focusCurrentControl();
		};

		GameOptionsPopup.prototype.checkAndCreateButton = function (btnData, sectionPrefix) {
			var button = null;
			btnData.text = _s(btnData.text);
			btnData.isGameOption = true;
			btnData.action = this.config.buttonHandler.changeSetting;
			var setting = btnData.settingsKey && sectionPrefix
				? this.settingsManager.getSetting(sectionPrefix, btnData.settingsKey) : null;

			switch (btnData.type) {
				case 'button':
					if (btnData.id === 'resetCumulativeScore') {
						button = this.createResetCumulativeScoreBtn(btnData);
					} else {
						button = this.buildButton(btnData);
					}
					break;
				case 'radio':
					button = this.buildRadioGroup(btnData, sectionPrefix, setting);
					break;
				case 'toggle':
					button = this.buildToggleButton(btnData, sectionPrefix, setting);
					break;
				case 'input':
					button = this.buildInput(btnData, sectionPrefix, setting);
					this.inputButton = button;
					break;
				case 'iconButton':
					button = this.buildIconButton(btnData);
				default:
					button = this.buildIconButton(btnData);
			}

			if (btnData.type === 'radio') {
				_.each(button.buttons, function (radioBtn) {
					this._modifyButtonInput(radioBtn);
				}.bind(this));
			} else {
				this._modifyButtonInput(button);
			}

			return button;
		};

		GameOptionsPopup.prototype.buildButton = function (btnData) {
			_.extend(btnData, {
				'threeSlice': {
					multistate: true,
					images: {
						'left': Absolute.AssetMap('buttonThreeSliceGrey.left'),
						'center': Absolute.AssetMap('buttonThreeSliceGrey.center'),
						'right': Absolute.AssetMap('buttonThreeSliceGrey.right')
					}
				},
				'width': Absolute.Coords.x(295),
				'height': Absolute.Coords.y(54),
				'maxWidth': Absolute.Coords.x(280),
				'minHeight': Absolute.Coords.y(54),
				'border': {
					'color': 0xffffff,
					'thickness': Absolute.Coords.x(5)
				},
				downFill: '#ffffff',
				'letterStyle': {
					font: 'Bold ' + Absolute.ScreenMetrics.getResScale() * 22 + "px Arial",
					fontFamily: 'segoe',
					fill: '#ffffff',
					align: 'left'
				}
			});
			var button = new MsftButton(btnData);
			return button;
		};

		GameOptionsPopup.prototype.buildRadioGroup = function (btnData, prefix, setting) {
			var button = new RadioGroup(_.extend(btnData, {
				'radioButtons': btnData.options,
				'title': btnData.text,
				'action': btnData.action,
				'settingPrefix': prefix,
				'setting': setting
			}));
			return button;
		};

		GameOptionsPopup.prototype.buildToggleButton = function (btnData, prefix, setting) {
			var button = new MsftToggleButton(_.extend(btnData, {
				'settingPrefix': prefix,
				'setting': setting
			}));
			return button;
		};

		GameOptionsPopup.prototype.buildInput = function (btnData, prefix, setting) {
			return new InputButton(_.extend(btnData, {
				'settingPrefix': prefix,
				'setting': setting,
				'validate': function (value) {
					return true;
				}
			}), this.game);
		};

		GameOptionsPopup.prototype.buildIconButton = function (btnData) {
			return new IconButton(btnData)
		};

		GameOptionsPopup.prototype.positionPopupContainer = function () {
			this.popupContainer.x = (Absolute.Coords.x(1920) - this.background.width) * 0.5;
			this.popupContainer.y = (Absolute.Coords.y(1080) - this.background.height) * 0.5 - Absolute.Coords.y(70);
		};

		GameOptionsPopup.prototype.updateChildIndexes = function () {
			this.popupContainer.setChildIndex(this.header, this.popupContainer.children.length - 1);
			this.popupContainer.setChildIndex(this.headerLabel, this.popupContainer.children.length - 1);
			this.popupContainer.setChildIndex(this.closeBtn, this.popupContainer.children.length - 1)
		};

		GameOptionsPopup.prototype.openPopup = function () {
			var self = this;
			this.showFadeInTween = new TWEEN.Tween({ alpha: this.alpha })
				.to({ alpha: 1 }, 250)
				.easing(TWEEN.Easing.Cubic.InOut)
				.onUpdate(function () {
					self.alpha = this.alpha;
					self.overlay.alpha = this.alpha;
				})
				.onComplete(function () {
				})
				.start();
		};

		GameOptionsPopup.prototype.closePopup = function () {
			var self = this;
			this.showFadeOutTween = new TWEEN.Tween({ alpha: this.alpha })
				.to({ alpha: 0 }, 250)
				.easing(TWEEN.Easing.Cubic.Out)
				.onUpdate(function () {
					self.alpha = this.alpha;
					self.overlay.alpha = this.alpha;
				})
				.onComplete(function () {
					self.showFadeOutTween.stop();
					self.destroy();
				})
				.start();
			this.onClose.handleEvent(this);
			if (this.inputButton) {
				this.inputButton.disable();
			}
		};

		GameOptionsPopup.prototype.destroy = function () {
			if (this.overlay.parent) this.overlay.parent.removeChild(this.overlay);
			if (this.parent) this.parent.removeChild(this);
			ScrollManager.remove(this);
		};

		GameOptionsPopup.prototype.doScroll = function (e) {
			var deltaY = 0;
			if (!e) e = window.event;
			if (e.wheelDelta) {
				deltaY = e.wheelDelta / 15;
			} else if (e.detail) {
				deltaY = -e.detail / 3;
			}
			this.scrollTo(this.bodyContainer.y + (deltaY * 10));
		};

		GameOptionsPopup.prototype.scrollTo = function (y) {
			var scaleY = Math.max(ScaleManager.scaleFactorY, 0.6);
			var availableHeight, partialHeight;
			availableHeight = this.bodyHeight + Absolute.Coords.y(65) + this.config.popupHeight * (1 - scaleY);
			partialHeight = this.background.height;
			if (availableHeight <= partialHeight) {
				this.bodyContainer.y = this.header.height;
				return;
			}
			this.bodyContainer.y = y;
			if (this.bodyContainer.y <= partialHeight - availableHeight) {
				this.bodyContainer.y = partialHeight - availableHeight;
			} else if (this.bodyContainer.y >= this.header.height) {
				this.bodyContainer.y = this.header.height;
			}
			if (this.sidebar) {
				this.sidebar
					.updateHandleByPercent(
						100 * Math.abs(this.bodyContainer.y - this.header.height)
						/ Math.abs(availableHeight - partialHeight + this.header.height));
			}
			if (this.inputButton) {
				this.inputButton.disable();
			}
		};

		GameOptionsPopup.prototype._modifyButtonInput = function (button) {
			if (Absolute.Platform.supportsTouch()) {
				this._bindButtonTouchInput(button);
				if (Absolute.Platform._isWindows() || (Absolute.Platform._isMac() && !Absolute.Platform._isIOS())) {
					this._bindButtonMouseInput(button);
				}
			} else {
				this._bindButtonMouseInput(button);
			}
		};

		GameOptionsPopup.prototype._bindButtonMouseInput = function (button) {
			var changeState = function (button, texture, hasBeenDown) {
				if (texture) button.setTexture(texture);
				button.hasBeenDown = hasBeenDown;
			};
			button.mousedown = function (evt) {
				changeState(button, button.downTexture, true);
			}.bind(button);
			button.mouseover = function (evt) {
				if (!button.hasBeenDown) return;
				changeState(button, button.overTexture, true);
			}.bind(button);
			button.mouseout = function (evt) {
				if (!button.hasBeenDown) return;
				changeState(button, button.upTexture, true);
			}.bind(button);
			button.mouseupoutside = function () {
				changeState(button, button.upTexture, false);
			}.bind(button);
			button.mouseup = function (evt) {
				if (!button.hasBeenDown) return;
				changeState(button, button.upTexture, false);
				if (typeof button.handleAction === "function") button.handleAction();
			}.bind(button);
		};


		GameOptionsPopup.prototype._bindButtonTouchInput = function (button) {
			var changeState = function (button, texture, hasBeenDown) {
				if (texture) button.setTexture(texture);
				button.hasBeenDown = hasBeenDown;
			};
			button.touchstart = function (evt) {
				changeState(button, button.downTexture, true);
			}.bind(button);
			button.touchend = function (evt) {
				if (!button.hasBeenDown) return;
				changeState(button, button.upTexture, false);
				if (typeof button.handleAction === "function") button.handleAction();
			}.bind(button);
			button.touchendoutside = function (evt) {
				changeState(button, button.upTexture, false);
			}.bind(button);
			button.touchmove = function (evt) {
				if (button.getBounds().contains(evt.global.x, evt.global.y)) return;
				changeState(button, button.upTexture, false);
			}.bind(button);
		};

		GameOptionsPopup.prototype.handleCommand = function (command, isMouseWheel) {
			if (isMouseWheel) return;
            if (this.warning) {
                this.warning.handleCommand(command, isMouseWheel);
                return;
            }
			switch (command) {
				case 'Right':
					this.startScrolling(12);
					break;
				case 'Left':
					this.startScrolling(-12);
					break;
				case 'Up':
					this.controlFocusManager.focusNextControl(-1);
					this.startScrolling(-9);
					break;
				case 'Down':
					this.controlFocusManager.focusNextControl(1)
					this.startScrolling(9);
					break;
				case 'Activate':
					this.controlFocusManager.activateCurrentControl();
					break;
				case 'Unfocus':
					this.controlFocusManager.unfocusCurrentControl();
					break;
				case 'Activate':
					this.controlFocusManager.activateCurrentControl();
					break;
				case 'Tab':
					this.focusGroupToggle = !this.focusGroupToggle;
					if (this.focusGroupToggle) {
						this.controlFocusManager.setFocusGroup('close', true);
						this.popupContainer.addChild(this.closeBtn.highlight);
						this.scrollTo(100);
					} else {
						this.controlFocusManager.setFocusGroup('body', true);
						this.popupContainer.removeChild(this.closeBtn.highlight);
						this.scrollTo(100);
					};
					break;
				case 'ShiftTab':
					this.focusGroupToggle = true;
					this.controlFocusManager.setFocusGroup('close', true);
					this.popupContainer.addChild(this.closeBtn.highlight);
					this.scrollTo(100);
					break;
			}
		};

		GameOptionsPopup.prototype.createResetCumulativeScoreBtn = function (btnData) {
            that = this;
			btnData.action = function () {
				warning = new DealWarningModal(this.game.ui.currentScreen,
					'dialogs.newDealHeadline', 'dialogs.newDealContent',
					function () {
						this.closePopup();
						var gameMode = this.game.solitaire.ActiveMode.Name;
						this.game.startGame(gameMode, null, true, true);
						warning.close();
                        that.warning = null;
					}.bind(this),
					function () {
						warning.close();
                        that.warning = null;
					}
				);
                this.warning = warning;
			}.bind(this);
			return this.buildButton(btnData);
		};

		GameOptionsPopup.prototype.startScrolling = function (delta) {
			this.sidebar.updateByArrow(delta);
		};

		return GameOptionsPopup;
	});

